export default __webpack_public_path__ + "static/media/earthCloud.67a542cb.png";